var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossInActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.13754 12.4938C0.843338 12.5111 0.553997 12.4122 0.330534 12.2178C-0.110178 11.7693 -0.110178 11.045 0.330534 10.5965L9.98068 0.83402C10.4391 0.400108 11.1583 0.424229 11.5873 0.887942C11.9751 1.30728 11.9977 1.9518 11.6402 2.39787L1.93318 12.2178C1.7126 12.4093 1.4279 12.5081 1.13754 12.4938Z",
    fill: "#969BA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7763 12.4938C10.4782 12.4925 10.1924 12.3728 9.98068 12.1603L0.330496 2.39783C-0.0778002 1.91549 -0.0222901 1.18959 0.454505 0.776501C0.880057 0.407833 1.50766 0.407833 1.93318 0.776501L11.6402 10.539C12.0984 10.973 12.1221 11.7007 11.6931 12.1643C11.676 12.1827 11.6584 12.2006 11.6402 12.2178C11.4025 12.4269 11.0897 12.5268 10.7763 12.4938Z",
    fill: "#969BA9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossInActive);
export default __webpack_public_path__ + "static/media/CrossInActive.84460f8228a7151ba1a8a1e08d85e4ae.svg";
export { ForwardRef as ReactComponent };